import React from 'react';
import { Button, Divider, Dropdown, Form, Grid, Header, Input, Loader, Popup, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { toast, ToastContainer } from 'react-toastify';
import request from '../../Util/request';
import { validate } from 'react-email-validator';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class CreateCandidates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            targetStudyProgramOptions: [],
            sourceStudyProgramSemester: '',
            committeeOptions: [],
        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.createCandidate = this.createCandidate.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.clearForm = this.clearForm.bind(this);
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }
    clearForm() {
        this.setState({
            firstName: '',
            lastName: '',
            phoneNumber: '',
            email: '',
            studentIdentificationNumber: '',
            sourceUniversity: '',
            sourceOrganizationalUnit: '',
            sourceStudyProgram: '',
            sourceDepartment: '',
            sourceStudyProgramSemester: null,
            date: '',
            comment: '',
            studyType: '',
            targetStudyProgram: '',
            committee: null
        });
    }
    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');
        axios.get('/study-programs/dto-by-faculty').then((res) => {
            let targetStudyProgramOptions = res.data ? res.data.map(el =>
                ({
                    value: el.studyProgram.id,
                    key: el.studyProgram.id,
                    additional: el.studyProgram.studyProgramStatus ? el.studyProgram.studyProgramStatus._key : el.studyProgram.id,
                    text: el.studyProgram.studyProgramBasic ? el.studyProgram.studyProgramBasic.name + ' | ' + el.studyProgram.name + ' | ' + el.studyCycles[0].displayName + (el.studyProgram.studyProgramBasic.comment ? ' | ' + el.studyProgram.studyProgramBasic.comment : '') : '',
                    description: el.studyProgram.description
                })) : res.data;
            this.setState({ targetStudyProgramOptions });
        });
        request.fetchCommitteeOptions().then(committeeOptions => this.setState({ committeeOptions }));
        request.fetchSemesterOptions().then(semesterOptions => this.setState({ semesterOptions }));
        request.fetchStudyTypeOptions().then(studyTypeOptions => this.setState({ studyTypeOptions }));
    }

    createCandidate() {
        if (!validate(this.state.email) || !this.state.firstName || !this.state.lastName || !this.state.date || !this.state.targetStudyProgram || !this.state.phoneNumber
            || !this.state.committee || !this.state.email || !this.state.sourceUniversity || !this.state.sourceOrganizationalUnit
            || !this.state.sourceDepartment || !this.state.sourceStudyProgram ||
            !this.state.studyType || !this.state.sourceStudyProgramSemester || !this.state.studentIdentificationNumber) {
            if (!validate(this.state.email) && this.state.email) toast(<FormattedMessage id="common.requiredEmailForm" />); else toast(<FormattedMessage id="common.requiredFields" />);
            if (!this.state.firstName) { this.setState({ firstNameErr: true }); } else { this.setState({ firstNameErr: false }); }
            if (!this.state.lastName) { this.setState({ lastNameErr: true }); } else { this.setState({ lastNameErr: false }); }
            if (!this.state.date) { this.setState({ dateErr: true }); } else { this.setState({ dateErr: false }); }
            if (!this.state.targetStudyProgram) { this.setState({ targetStudyProgramErr: true }); } else { this.setState({ targetStudyProgramErr: false }); }
            if (!this.state.committee) { this.setState({ committeeErr: true }); } else { this.setState({ committeeErr: false }); }
            if (!this.state.phoneNumber) { this.setState({ phoneNumberErr: true }); } else { this.setState({ phoneNumberErr: false }); }
            if (!this.state.email) { this.setState({ emailErr: true }); } else { this.setState({ emailErr: false }); }
            if (!validate(this.state.email)) { this.setState({ emailErr: true }); } else { this.setState({ emailErr: false }); }
            if (!this.state.sourceUniversity) { this.setState({ sourceUniversityErr: true }); } else { this.setState({ sourceUniversityErr: false }); }
            if (!this.state.sourceOrganizationalUnit) { this.setState({ sourceOrganizationalUnitErr: true }); } else { this.setState({ sourceOrganizationalUnitErr: false }); }
            // if (!this.state.sourceDepartment) { this.setState({ sourceDepartmentErr: true }); } else { this.setState({ sourceDepartmentErr: false }); }
            // if (!this.state.sourceStudyProgram) { this.setState({ sourceStudyProgramErr: true }); } else { this.setState({ sourceStudyProgramErr: false }); }
            if (!this.state.studyType) { this.setState({ studyTypeErr: true }); } else { this.setState({ studyTypeErr: false }); }
            if (!this.state.sourceStudyProgramSemester) { this.setState({ sourceStudyProgramSemesterErr: true }); } else { this.setState({ sourceStudyProgramSemesterErr: false }); }
            if (!this.state.studentIdentificationNumber) { this.setState({ studentIdentificationNumberErr: true }); } else { this.setState({ studentIdentificationNumberErr: false }); }
        } else {
            this.setState({ disableCreateButton: true });
            let obj = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                phoneNumber: this.state.phoneNumber,
                email: this.state.email,
                studentIdentificationNumber: this.state.studentIdentificationNumber,
                sourceUniversity: this.state.sourceUniversity,
                sourceOrganizationalUnit: this.state.sourceOrganizationalUnit,
                sourceStudyProgram: this.state.sourceStudyProgram,
                sourceDepartment: this.state.sourceDepartment,
                sourceStudyProgramSemesterId: this.state.sourceStudyProgramSemester,
                applicationDate: this.state.date,
                comment: '',
                targetStudyTypeId: this.state.studyType,
                targetStudyProgramId: this.state.targetStudyProgram,
                committeeId: this.state.committee

            };
            request.createCandidate(obj)
                .then(() => {
                    this.setState({ disableCreateButton: false });
                    this.clearForm();
                    toast('Uspješno ste dodali kandidata!');
                })
                .catch(err => {
                    toast('Dodavanje kandidata nije uspjelo!');
                    console.log('Failed to create candidate.');
                    this.setState({ disableCreateButton: false });
                });
        }
    }
    render() {
        return (

            <div>
                <Segment clearing vertical>

                    <Form>
                        <Grid columns={2}>
                            <Grid.Column>
                                <Divider horizontal>
                                    <Header as="h4">
                                        Osnovni podaci
                                    </Header>
                                </Divider>
                                <Form.Group widths="equal">
                                    <Form.Field required error={this.state.firstNameErr}>
                                        <label>
                                            Ime
                                        </label>
                                        <input
                                            required
                                            fluid
                                            placeholder="Ime"
                                            control={Input}
                                            value={this.state.firstName}
                                            name="firstName"
                                            onChange={(e) => this.setState({ firstName: e.target.value })}
                                        />
                                    </Form.Field>
                                    <Form.Field required error={this.state.lastNameErr}>
                                        <label>
                                            Prezime
                                        </label>
                                        <input
                                            required
                                            fluid
                                            placeholder="Prezime"
                                            control={Input}
                                            value={this.state.lastName}
                                            name="lastName"
                                            onChange={(e) => this.setState({ lastName: e.target.value })}
                                        />
                                    </Form.Field>
                                </Form.Group>


                                <Form.Field
                                    required
                                    control={DateTimePicker}
                                    label="Datum podnošenja zahtjeva"
                                    format="D. M. YYYY."
                                    value={this.state.date}
                                    time={false}
                                    onChange={this.handleDateChange.bind(null, 'date')}
                                    style={{ borderWidth: '0px' }}
                                    error={this.state.dateErr}
                                />
                                <Form.Field
                                    required
                                    error={this.state.targetStudyProgramErr}
                                >
                                    <label>
                                        Studijski program na koji se prebacuje
                                    </label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite studijski program"
                                        value={this.state.targetStudyProgram}
                                        onChange={this.handleInputChange}
                                        name="targetStudyProgram"
                                        options={this.state.targetStudyProgramOptions.filter((e) => (e.additional !== 'archived'))}
                                        search
                                        fluid
                                        selection

                                    />
                                </Form.Field>
                                <Form.Field
                                    required
                                    error={this.state.committeeErr}
                                >
                                    <label>
                                        Komisija
                                    </label>
                                    {/* eslint-disable-next-line react/jsx-no-undef */}
                                    <Dropdown
                                        selection
                                        name="committee"
                                        value={this.state.committee}
                                        options={this.state.committeeOptions}
                                        placeholder="Odaberite komisiju"
                                        onChange={this.handleInputChange}
                                        clearable
                                    >
                                        <Dropdown.Menu >
                                            {
                                                this.state.committeeOptions.map((el, index) =>
                                                    (<Popup
                                                        trigger={<Dropdown.Item text={el.text} value={el.value} name="committee" onClick={this.handleInputChange} />}
                                                        content={el.committeeMembers.map(e => (<div>{e.firstName + ' ' + e.lastName}</div>))}
                                                        hideOnScroll
                                                        position="left center"
                                                    />))
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Form.Field>
                                <Form.Group widths="equal">
                                    <Form.Field required error={this.state.phoneNumberErr}>
                                        <label>
                                            Broj telefona
                                        </label>
                                        <input
                                            required
                                            fluid
                                            placeholder="Broj telefona"
                                            control={Input}
                                            value={this.state.phoneNumber}
                                            name="phoneNumber"
                                            onChange={(e) => this.setState({ phoneNumber: e.target.value })}
                                        />
                                    </Form.Field>
                                    <Form.Field required error={this.state.emailErr}>
                                        <label>
                                            Email
                                        </label>
                                        <input
                                            required
                                            fluid
                                            placeholder="Email"
                                            control={Input}
                                            value={this.state.email}
                                            name="email"
                                            onChange={(e) => this.setState({ email: e.target.value })}
                                        />
                                    </Form.Field>
                                </Form.Group>

                            </Grid.Column>

                            <Grid.Column>

                                <Divider horizontal>
                                    <Header as="h4">
                                        Podaci o prethodnom studiju
                                    </Header>
                                </Divider>
                                <Form.Group widths="equal">
                                    <Form.Field required error={this.state.sourceUniversityErr}>
                                        <label>
                                            Univerzitet
                                        </label>
                                        <input
                                            required
                                            fluid
                                            placeholder="Univerzitet"
                                            control={Input}
                                            value={this.state.sourceUniversity}
                                            name="sourceUniversity"
                                            onChange={(e) => this.setState({ sourceUniversity: e.target.value })}
                                        />
                                    </Form.Field>
                                    <Form.Field required error={this.state.sourceOrganizationalUnitErr}>
                                        <label>
                                            Organizaciona jedinica
                                        </label>
                                        <input
                                            required
                                            fluid
                                            placeholder="Organizaciona jedinica"
                                            control={Input}
                                            value={this.state.sourceOrganizationalUnit}
                                            name="sourceOrganizationalUnit"
                                            onChange={(e) => this.setState({ sourceOrganizationalUnit: e.target.value })}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                <Form.Field error={this.state.sourceDepartmentErr}>
                                    <label>
                                        Odsjek
                                    </label>
                                    <input
                                        fluid
                                        placeholder="Odsjek"
                                        control={Input}
                                        value={this.state.sourceDepartment}
                                        name="sourceDepartment"
                                        onChange={(e) => this.setState({ sourceDepartment: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field error={this.state.sourceStudyProgramErr}>
                                    <label>
                                        Smjer
                                    </label>
                                    <input
                                        fluid
                                        placeholder="Smjer"
                                        control={Input}
                                        value={this.state.sourceStudyProgram}
                                        name="sourceStudyProgram"
                                        onChange={(e) => this.setState({ sourceStudyProgram: e.target.value })}
                                    />
                                </Form.Field>

                                <Form.Field
                                    required
                                    error={this.state.studyTypeErr}
                                >
                                    <label>
                                        Tip studiranja
                                    </label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite tip"
                                        value={this.state.studyType}
                                        onChange={this.handleInputChange}
                                        name="studyType"
                                        options={this.state.studyTypeOptions}
                                        search
                                        fluid
                                        selection

                                    />
                                </Form.Field>
                                <Form.Group widths="equal">
                                    <Form.Field
                                        required
                                        error={this.state.sourceStudyProgramSemesterErr}
                                    >
                                        <label>
                                            Zadnji upisani sesmestar
                                        </label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Odaberite semestar"
                                            value={this.state.sourceStudyProgramSemester}
                                            onChange={this.handleInputChange}
                                            name="sourceStudyProgramSemester"
                                            options={this.state.semesterOptions}
                                            search
                                            fluid
                                            selection

                                        />
                                    </Form.Field>
                                    <Form.Field required error={this.state.studentIdentificationNumberErr}>
                                        <label>
                                            Broj indexa
                                        </label>
                                        <input
                                            required
                                            fluid
                                            placeholder="Broj indexa"
                                            control={Input}
                                            value={this.state.studentIdentificationNumber}
                                            name="studentIdentificationNumber"
                                            onChange={(e) => this.setState({ studentIdentificationNumber: e.target.value })}
                                        />
                                    </Form.Field>
                                </Form.Group>

                            </Grid.Column>
                        </Grid>
                    </Form>


                    <Loader active={this.state.disableCreateButton} />
                    <Button
                        basic
                        color="blue"
                        disabled={this.state.disableCreateButton}
                        floated="right"
                        onClick={this.props.closeForm}
                    >
                        Odustani

                    </Button>

                    <Button primary color="blue" disabled={this.state.disableCreateButton} onClick={this.createCandidate} floated="right">
                        Kreiraj

                    </Button>

                    <ToastContainer hideProgressBar />
                </Segment>


            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CreateCandidates/CreateCandidates.js